module.exports = __webpack_public_path__ + "img/FI10786932.d6d8eddd.png";